import PaymentsHistory from './PaymentsHistory';

export default PaymentsHistory;
